module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAFBAMAAACDVBAcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUAAAAlKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS221sbDAAAADnRSTlMAaPr7Q+0l19gRuQSTlPLWDecAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKUlEQVQIHWMQegcEhgwsce/ePXVgYEh/966NgYGBc92rCQxAsOc2AwMAGwoN8M9k0ZwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/down-grey1.png
// module id = 770
// module chunks = 0 1 2 3 4